'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _components = require('../../components');

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTdFossilFinanceGrade = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTdFossilFinanceGrade, _Component);

  //
  function IyvListTdFossilFinanceGrade(props) {
    (0, _classCallCheck3.default)(this, IyvListTdFossilFinanceGrade);

    //
    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListTdFossilFinanceGrade.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdFossilFinanceGrade)).call(this, props));

    var fieldName = props.fieldName;
    if (props.fieldName === 'fossil_bank_score') {
      fieldName = 'grade_fossil_bank';
    }
    if (props.fieldName === 'fossil_insure_score') {
      fieldName = 'grade_fossil_insure';
    }
    var val = props.shareclass[fieldName];

    var financeRange = 'undefined';
    var financeRangeName = 'err';
    switch (_convert2.default.int(val)) {
      case 1:
        financeRange = 'low';
        financeRangeName = 'A';
        break;
      case 2:
        financeRange = 'below';
        financeRangeName = 'B';
        break;
      case 3:
        financeRange = 'above';
        financeRangeName = 'C';
        break;
      case 4:
        financeRange = 'high';
        financeRangeName = 'D';
        break;
      case 5:
        financeRange = 'extreme';
        financeRangeName = 'F';
        break;
      case -1:
        break;
      default:
        break;
    }
    //
    _this.state = {
      financeRange: financeRange,
      financeRangeName: financeRangeName
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListTdFossilFinanceGrade, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'td',
        {
          styleName: 'col' + (this.props.mobile ? '-right' : ''),
          onClick: this.props.clickShareclass(this.props.shareclass, 'fossil-finance-insurance')
        },
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper-w-tail' },
          _react2.default.createElement(
            'span',
            { styleName: 'footrange-' + this.state.financeRange },
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-circle' }),
            '\xA0',
            _react2.default.createElement(
              'span',
              { styleName: 'grade-font' },
              this.state.financeRangeName
            )
          ),
          '\xA0'
        )
      );
    }
  }]);
  return IyvListTdFossilFinanceGrade;
}(_react.Component), _class2.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func,
  fieldName: _react.PropTypes.string.isRequired,
  mobile: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = IyvListTdFossilFinanceGrade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTdFossilFinanceGrade.js
// module id = 1375
// module chunks = 0